export default __webpack_public_path__ + "static/media/pdf.ee0aebea.svg";